import axios from 'axios';
import { USER_CONFIGURATION_BASE_URL, USER_CONFIGURATION_UPSERT, USER_API_BASE_URL } from '../../constants/api';
import { attachUnauthorizedInterceptor } from '../client';

export const userConfigClient = axios.create({
  baseURL: USER_CONFIGURATION_BASE_URL,
  headers: { 'Content-Type': 'application/json' },
  withCredentials: true
});

export const userClient = axios.create({
  baseURL: USER_API_BASE_URL,
  headers: { 'Content-Type': 'application/json' },
  withCredentials: true
});

[userConfigClient, userClient].forEach(attachUnauthorizedInterceptor);

export const fetchUserConfiguration = (body = {}) => userConfigClient.post('', body);

export const upsertUIConfiguration = (body = {}) => userConfigClient.post(USER_CONFIGURATION_UPSERT, body);

export const fetchFeatureHub = () => userClient.get('/featureproxy');
